import Image from 'next/image';
import Link from 'next/link';
import { bottomImage3, filmImage } from '../assets/images';
import { CheckMark, BlueCheckMark, ArrowBlackLong } from '../assets/icons';
const BottomImageTwo = ({
  path,
  overlayImage = true,
  imgSrc = bottomImage3,
  showGoals = true,
  title = (
    <>
      {' '}
      Consult a doctor from
      <br className='tw-hidden md:tw-block' /> the comfort of your
      <br className='tw-hidden md:tw-block' /> home — no waiting.
    </>
  ),
  btnText = 'Get Treatment Online',
}) => {
  return (
    <div className='bottomImageTwoWrapper'>
      <div className='theFilm'>
        <div className='theFilmContent'>
          <h2
            style={{ lineHeight: '3rem' }}
            className='tw-text-[2.5rem] tw-font-semibold tw-text-white'
          >
            {title}
          </h2>
          {showGoals && (
            <div className='theCtaList'>
              {ctaGoals.map((item) => (
                <div key={item.id} className='theListItem'>
                  <span>
                    <BlueCheckMark stroke={'#fff'} />
                  </span>
                  <span
                    style={{
                      color: '#FFFFFF',
                      fontWeight: '400',
                      fontSize: '0.875rem',
                    }}
                  >
                    {item.text}
                  </span>
                </div>
              ))}
            </div>
          )}

          <Link href={`${path ? path : '/services'}`}>
            <div className='hero-home-new-cta'>
              {' '}
              <span className='theFilmCta'>
                {btnText}
                <ArrowBlackLong />
              </span>
            </div>
          </Link>
        </div>
        {overlayImage && (
          <div className='thebottomRightImage'>
            <Image
              src={filmImage}
              layout='fill'
              objectFit='contain'
              alt='telemedicine'
              quality={80}
            />
          </div>
        )}
      </div>
      <Image
        src={imgSrc}
        layout='fill'
        objectFit='cover'
        alt='a man sitting comfortably at home'
        objectPosition='50% 20%'
      />
    </div>
  );
};

export default BottomImageTwo;
const ctaGoals = [
  { id: 1, text: 'Get expert care right away' },
  { id: 2, text: ' Get personalized prescriptions' },
  { id: 3, text: 'Trusted by thousands of patients' },
];
